<template>
  <footer class="admin-footer">
    <ul>
      <li><router-link to="/admin/dashboard">Home</router-link></li>
      <!-- <li><a href="admin-users.html">Users</a></li>
      <li><a href="#">Data Exporting</a></li>
      <li><a href="dashboard.html">My Account</a></li> -->
      <li><a href="" v-if="isLoggedIn" @click.prevent="logout">Logout</a></li>
    </ul>

    <br><br>
    <p>Copyright © 2019 Mercury Fulfillment Systems, Inc. All Rights Reserved.</p>
  </footer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('auth', [
      'isLoggedIn'
    ])
  },
  methods: {
    ...mapActions('auth', {
      storeLogout: 'logout'
    }),
    logout () {
      this.storeLogout()
        .then(() => {
          this.$router.push({ name: 'AdminLogin' })
        })
    }
  }
}
</script>
